export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserFilter.vue?vue&type=template&id=2195a3d8&"


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/users/UserFilter.vue?vue&type=template&id=2195a3d8&
// module id = 1431
// module chunks = 0